import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Pages
// Home Pages
const Home = React.lazy(() => import("./components/pages/Home"));
const Homeone = React.lazy(() => import("./components/pages/Homeone"));
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const Homethree = React.lazy(() => import("./components/pages/Homethree"));
const Homefour = React.lazy(() => import("./components/pages/Homefour"));
const Homefive = React.lazy(() => import("./components/pages/Homefive"));
// Vendor
const Vendor = React.lazy(() => import("./components/pages/Vendor"));
const Vendorone = React.lazy(() => import("./components/pages/Vendorone"));
const Vendortwo = React.lazy(() => import("./components/pages/Vendortwo"));
const Addvendor = React.lazy(() => import("./components/pages/Addvendor"));
const Listview = React.lazy(() => import("./components/pages/Listview"));
// Innerpages
const Exdeals = React.lazy(() => import("./components/pages/Exdeals"));
const About = React.lazy(() => import("./components/pages/About"));
const Reviews = React.lazy(() => import("./components/pages/Reviews"));
const Checkout = React.lazy(() => import("./components/pages/Checkout"));
const Orderdetails = React.lazy(() => import("./components/pages/Orderdetails"));
// Listing
const Listingfull = React.lazy(() => import("./components/pages/Listingfull"));
const Listingleft = React.lazy(() => import("./components/pages/Listingleft"));
const Listingright = React.lazy(() => import("./components/pages/Listingright"));
const Listingdetails = React.lazy(() => import("./components/pages/Listingdetails"));
// Shop
const Shopfull = React.lazy(() => import("./components/pages/Shopfull"));
const Shopleft = React.lazy(() => import("./components/pages/Shopleft"));
const Shopright = React.lazy(() => import("./components/pages/Shopright"));
const Productdetails = React.lazy(() => import("./components/pages/Productdetails"));
const Vendormap = React.lazy(() => import("./components/pages/Vendormap"));
// Additional
const Login = React.lazy(() => import("./components/pages/Login"));
const Register = React.lazy(() => import("./components/pages/Register"));
const Geolocator = React.lazy(() => import("./components/pages/Geolocator"));
const Comparison = React.lazy(() => import("./components/pages/Comparison"));
// Blog
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogtwo = React.lazy(() => import("./components/pages/Blogtwo"));
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          {/* Homepages */}
          <Route exact path="/" component={Home} />
          <Route path="/home-v1" component={Homeone} />
          <Route path="/home-v2" component={Hometwo} />
          <Route path="/home-v3" component={Homethree} />
          <Route path="/home-v4" component={Homefour} />
          <Route path="/home-v5" component={Homefive} />
          {/* Vendor */}
          <Route path="/vendor" component={Vendor} />
          <Route path="/vendor-v1" component={Vendorone} />
          <Route path="/vendor-v2" component={Vendortwo} />
          <Route path="/add-vendor" component={Addvendor} />
          <Route path="/list-view" component={Listview} />
          {/* Innerpages */}
          <Route path="/ex-deals" component={Exdeals} />
          <Route path="/about" component={About} />
          <Route path="/reviews" component={Reviews} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/order-details" component={Orderdetails} />
          {/* Listing */}
          <Route path="/listing-full" component={Listingfull} />
          <Route path="/listing-left" component={Listingleft} />
          <Route path="/listing-right" component={Listingright} />
          <Route path="/listing-detail/:id" component={Listingdetails} />
          {/* Shop */}
          <Route path="/shop-full" component={Shopfull} />
          <Route path="/shop-left" component={Shopleft} />
          <Route path="/shop-right" component={Shopright} />
          <Route path="/product-details/:id" component={Productdetails} />
          <Route path="/vendor-map" component={Vendormap} />
          {/* Additional */}
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/geo-locator" component={Geolocator} />
          <Route path="/comparison" component={Comparison} />
          {/* Blog */}
          <Route path="/blog" component={Blog} />
          <Route path="/blog-v2" component={Blogtwo} />
          <Route path="/blog-details/:id" component={Blogdetails} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
